import { BANGALORE, CHENNAI, DELHI, HYDERABAD, MUMBAI, PUNE } from "../../constants/AzureDevops";

export const defaultFaqs = [
  {
    question: "What is the PaperLive DevOps and Multi-Cloud Certification?",
    answer:
      "This is a six-month online program that is both demanding and interesting. It is specifically created for both freshers and working professionals who wish to accelerate their entry into cloud and DevOps jobs, build a professional network, and gain practical knowledge and skills. Microsoft is the one who grants the certification.",
  },
  {
    question: "What are the mock interview eligibility criteria for placements?",
    answer:
      "To be eligible for placements, candidates must achieve a minimum average score of 40% across all three mock interviews.If a candidate is unable to secure a 40% average, they will be moved to the Performance Improvement Program (PIP) for additional guidance, practice, and support.Once the candidate successfully achieves a 40% average, they will be transitioned back to the placement process."
  },
  {
    question: "What can I anticipate from the for DevOps and Cloud job ready program?",
    answer:
      "Anticipate to complete multiple industry-relevant exercises that are modelled after real-world work environments, enabling you to become a cloud/DevOps expert on par with top industry standards. Through this curriculum, students will develop their technical soundness and learn how to think beyond the box.",
  },
  {
    question: "What kind of educational experience can I anticipate?",
    answer:
      "This curriculum will combine recorded content on several subjects with live lectures delivered in a boot camp style. A combination of interactive lectures from well-known academics and business executives will make up the curriculum. At least one cloud domain certification is held by each of our industry specialists, and many of them possess several domain certifications. During this course, you can anticipate a lively setting where you will enhance your expertise in the field and grow your professional network.",
  },
  {
    question: "What amount of hours a week is needed of me?",
    answer:
      "The program schedule is structured to make sure you can work a job and successfully complete your studies. It should be sufficient to dedicate 10–12 hours per week to the program. That being said, the more time you invest, the more you will learn from the curriculum.",
  },
];

export const executiveFaqs = [
  {
    question: "What is the fee for PaperLive's DevOps course online, and are EMI options available?",
    answer: "The course fee is competitively priced for the Indian market, and no-cost EMI options are available through major banks and NBFCs — making the DevOps training online accessible without upfront financial pressure."
  },
  {
    question: "Are there any scholarships or early-bird discounts on this DevOps certification program?",
    answer: "Yes, PaperLive periodically offers early-bird pricing and merit-based scholarships on the DevOps certification program. Reach out to the admissions team to check current offers before enrolling."
  },
  {
    question: "What is the refund policy for this DevOps training online?",
    answer: "PaperLive offers a structured refund policy — if you're unsatisfied within the initial sessions of the DevOps training online, you can claim a refund as per the terms shared at enrollment."
  },
  {
    question: "Is there a free demo class available before I pay for the DevOps course?",
    answer: "Yes, PaperLive offers a free demo session for the DevOps course so you can evaluate the teaching quality, curriculum depth, and instructor before committing."
  },
  {
    question: "Does this DevOps training online cover CI/CD pipeline setup with Jenkins and GitHub Actions?",
    answer: "Yes — building and managing CI/CD pipelines using Jenkins, GitHub Actions, and GitLab CI is a core module in the DevOps training online, with hands-on project work included."
  },
  {
    question: "Is Docker and Kubernetes part of this DevOps course online?",
    answer: "Docker containerization and Kubernetes orchestration are both covered in depth in this DevOps course online, including real-world cluster deployments and production-grade configurations."
  },
  {
    question: "Does the DevOps certification curriculum include Infrastructure as Code (Terraform, Ansible)?",
    answer: "Yes. Terraform for cloud provisioning and Ansible for configuration management are dedicated modules in the DevOps certification curriculum — both are heavily sought after by employers."
  },
  {
    question: "Is monitoring and observability (Prometheus, Grafana, ELK) covered in this DevOps training?",
    answer: "The DevOps training includes a full observability module covering Prometheus, Grafana dashboards, and the ELK stack — skills that directly come up in senior DevOps interviews."
  },
  {
    question: "What scripting languages are taught in this DevOps course online?",
    answer: "Shell scripting, Python for automation, and YAML configuration are all covered in the DevOps course online — the scripting foundation every DevOps engineer needs on the job."
  },
  {
    question: "Is Git and version control covered as part of this DevOps training online?",
    answer: "Yes — Git workflows, branching strategies, and code review practices form the foundation of the DevOps training online before advancing into CI/CD and cloud modules."
  },
  {
    question: "Are the DevOps course online classes held on weekdays, weekends, or both?",
    answer: "PaperLive offers both weekday evening and weekend batches for the DevOps course online — specifically designed so working professionals don't have to choose between job and upskilling."
  },
  {
    question: "How many hours per week does this DevOps training online require?",
    answer: "Expect to invest 8–12 hours per week in the DevOps training online, including live sessions, lab practice, and assignments — manageable alongside a full-time role."
  },
  {
    question: "What happens if I miss a live session of this DevOps certification program?",
    answer: "All live sessions are recorded and made available within 24 hours, so missing a class in the DevOps certification program won't set you back — you can catch up at your own pace."
  },
  {
    question: "Can I access the DevOps course online content on mobile?",
    answer: "Yes, all recorded sessions and course material for the DevOps course online are accessible via mobile browser, so you can learn during your commute or between meetings."
  },
  {
    question: "What system configuration do I need to take this DevOps training online?",
    answer: "A laptop with 8GB RAM and a stable internet connection is sufficient. All lab environments in the DevOps training online are cloud-hosted — no expensive local infrastructure needed."
  },
  {
    question: "Will I get access to live cloud lab environments during this DevOps course?",
    answer: "Yes — the DevOps course provides access to live cloud lab environments on AWS, Azure, and GCP, so you practice on real infrastructure, not simulations."
  },
  {
    question: "What DevOps job roles can I target after completing this DevOps certification?",
    answer: "This DevOps certification prepares you for roles like DevOps Engineer, Site Reliability Engineer (SRE), Cloud Infrastructure Engineer, Platform Engineer, and Release Manager."
  },
  {
    question: "What is the average salary for a DevOps-certified professional in India?",
    answer: "DevOps-certified professionals in India typically earn ₹7–20 LPA depending on experience level, with IIT-backed credentials like this DevOps certification helping in salary negotiations."
  },
  {
    question: "Does PaperLive offer resume building and interview prep as part of the DevOps training?",
    answer: "Yes — the DevOps training includes resume writing support, LinkedIn profile optimization, and mock interview sessions tailored specifically for DevOps hiring rounds."
  },
  {
    question: "Does PaperLive have company tie-ups for DevOps hiring after the course?",
    answer: "PaperLive has active hiring partnerships with companies specifically recruiting DevOps-certified professionals, giving graduates access to exclusive referral opportunities post-course."
  },
  {
    question: "How does this DevOps course online compare to vendor certifications like AWS DevOps Professional or CKA?",
    answer: "Vendor certifications are platform-specific, while this DevOps course online covers the full DevOps lifecycle across multi-cloud environments — making you more versatile and interview-ready across a wider range of employers."
  },
  {
    question: "Is this DevOps training online better than a full-time bootcamp for someone already employed in IT?",
    answer: "Unlike bootcamps that require a career break, this DevOps training online is designed around working professionals — with flexible schedules, recorded backups, and a paced curriculum that doesn't demand full-time availability."
  },
  {
    question: "Why should I choose PaperLive's DevOps certification over a Udemy or Coursera course?",
    answer: "Self-paced platforms give you videos — PaperLive's DevOps certification gives you live instruction, real cloud labs, mentor access, TIH-IIT Patna credentialing, and placement support. It's a program, not just content."
  },
  {
    question: "Is there a peer community or study group for this DevOps course online batch?",
    answer: "Every DevOps course online batch gets a dedicated peer community group for doubt-sharing, project collaboration, and networking with batchmates across India."
  },
  {
    question: "How many doubt-clearing sessions are included in this DevOps training online?",
    answer: "The DevOps training online includes weekly live doubt-clearing sessions with instructors, plus async support via the community channel — so no question goes unanswered."
  },
  {
    question: "Who are the instructors for this DevOps training — academics or industry professionals?",
    answer: "All instructors in this DevOps training are active industry practitioners with hands-on experience at product companies and global IT firms — not just academics or theorists."
  },
  {
    question: "Is the TIH-IIT Patna DevOps certification verifiable by employers?",
    answer: "Yes — the DevOps certification issued by TIH-IIT Patna is digitally verifiable and can be shared directly on LinkedIn or submitted to employers via a unique credential ID."
  },
  {
    question: "Will this DevOps certification help me get a job abroad or only in India?",
    answer: "The DevOps certification curriculum is globally aligned — covering tools and cloud platforms used worldwide. Many PaperLive graduates have leveraged it for opportunities in the Middle East, UK, and Southeast Asia."
  },
  {
    question: "How is this DevOps certification different from a general IT certificate?",
    answer: "Unlike generic IT certificates, this DevOps certification is domain-specific, backed by TIH-IIT Patna, and tied to hands-on project completion — making it far more credible in a DevOps job interview."
  },
  {
    question: "Does completing this DevOps course online make me eligible for any government or PSU tech roles?",
    answer: "The TIH-IIT Patna credential attached to this DevOps course online adds institutional legitimacy that is recognized in government tech hiring contexts, particularly for roles in digital transformation and cloud infrastructure projects."
  }
];

export const bangaloreFaqs = [
  {
    question: "What is the fee for this DevOps course online in Bangalore, and are EMI options available?",
    answer: "The fee is competitively priced for the Indian market, and no-cost EMI options are available through leading banks and NBFCs."
  },
  {
    question: "Are there scholarships or early-bird discounts on this DevOps certification in Bangalore?",
    answer: "Yes, early-bird pricing and merit-based scholarships are offered periodically. Reach out to the admissions team to check current offers."
  },
  {
    question: "What is the refund policy for this DevOps training in Bangalore?",
    answer: "A structured refund policy is in place — if you're unsatisfied within the initial sessions, you can claim a refund as per the terms shared at enrollment."
  },
  {
    question: "Is a free demo class available before I pay for the DevOps course in Bangalore?",
    answer: "Yes, a free demo session lets you evaluate teaching quality, curriculum depth, and the instructor before committing."
  },
  {
    question: "Does this DevOps training online in Bangalore cover CI/CD pipeline setup with Jenkins and GitHub Actions?",
    answer: "Yes — building and managing CI/CD pipelines using Jenkins, GitHub Actions, and GitLab CI is a core module, backed by hands-on project work."
  },
  {
    question: "Is Docker and Kubernetes part of this DevOps course in Bangalore?",
    answer: "Yes, both are covered in depth, including real-world cluster deployments and production-grade configurations."
  },
  {
    question: "Does the DevOps certification curriculum include Infrastructure as Code (Terraform, Ansible)?",
    answer: "Yes — Terraform for cloud provisioning and Ansible for configuration management each get dedicated modules."
  },
  {
    question: "Is monitoring and observability (Prometheus, Grafana, ELK) covered in this DevOps training in Bangalore?",
    answer: "Yes, a full observability module walks through Prometheus, Grafana dashboards, and the ELK stack."
  },
  {
    question: "What scripting languages are taught in this DevOps course in Bangalore?",
    answer: "Shell scripting, Python for automation, and YAML configuration."
  },
  {
    question: "Is Git and version control covered as part of this DevOps training in Bangalore?",
    answer: "Yes — Git workflows, branching strategies, and code review practices form the foundation before moving into CI/CD and cloud modules."
  },
  {
    question: "Are the DevOps course online classes held on weekdays, weekends, or both?",
    answer: "Both weekday evening and weekend batches are available."
  },
  {
    question: "How many hours per week does this DevOps training in Bangalore require?",
    answer: "Around 8–12 hours per week, including live sessions, lab practice, and assignments."
  },
  {
    question: "What happens if I miss a live session of this DevOps certification course?",
    answer: "All sessions are recorded and made available within 24 hours."
  },
  {
    question: "Can I access the DevOps course content on mobile?",
    answer: "Yes, all recorded sessions and materials are accessible through a mobile browser."
  },
  {
    question: "What system configuration do I need for this DevOps training in Bangalore?",
    answer: "A laptop with 8GB RAM and a stable internet connection is sufficient — all lab environments are cloud-hosted."
  },
  {
    question: "Will I get access to live cloud lab environments during this DevOps course?",
    answer: "Yes — live cloud labs on AWS, Azure, and GCP let you practice on real infrastructure."
  },
  {
    question: "Is PaperLive Learning the Best DevOps Training Institute in Bangalore?",
    answer: "Yes. PaperLive Learning is a leading DevOps training institute in Bangalore, offering live instructor-led training, hands-on projects, AWS, Azure & GCP, Microsoft-certified trainers, and dedicated placement assistance to help learners build job-ready DevOps skills."
  },
  {
    question: "What DevOps job roles can I target after completing this DevOps training in Bangalore?",
    answer: "DevOps Engineer, SRE, Cloud Infrastructure Engineer, Platform Engineer, and Release Manager, among others."
  },
  {
    question: "What is the average salary for a DevOps-certified professional in India?",
    answer: "Typically ₹7–20 LPA depending on experience, with the IIT-backed credential often strengthening salary negotiations."
  },
  {
    question: "Is resume building and interview prep included as part of this DevOps training in Bangalore?",
    answer: "Yes — resume writing support, LinkedIn optimization, and mock interviews tailored specifically for DevOps hiring rounds."
  },
  {
    question: "Are there company tie-ups for DevOps hiring after the course?",
    answer: "Yes — active hiring partnerships give graduates exclusive referral opportunities after course completion."
  },
  {
    question: "How does this DevOps course in Bangalore compare to vendor certifications like AWS DevOps Professional or CKA?",
    answer: "Vendor certifications tend to be platform-specific, while this course covers the full DevOps lifecycle across multi-cloud environments."
  },
  {
    question: "Is this DevOps training in Bangalore better suited than a full-time bootcamp for someone already working in IT?",
    answer: "It's built around working professionals — flexible schedules, recorded session backups, and no need for full-time availability."
  },
  {
    question: "Why choose this DevOps training in Bangalore over a Udemy or Coursera course?",
    answer: "Self-paced platforms mainly offer pre-recorded videos; this program adds live instruction, real cloud labs, mentor access, TIH-IIT Patna credentialing, and dedicated placement support."
  },
  {
    question: "Is there a peer community or study group for this DevOps course in Bangalore batch?",
    answer: "Yes — every batch gets a dedicated peer community for doubt-sharing, project collaboration, and networking."
  },
  {
    question: "How many doubt-clearing sessions are included in this DevOps training in Bangalore?",
    answer: "Weekly live doubt-clearing sessions, plus asynchronous support through the community channel."
  },
  {
    question: "Who are the instructors for this DevOps training — academics or industry professionals?",
    answer: "All instructors are active industry practitioners with hands-on experience at product companies and global IT firms."
  },
  {
    question: "Is the TIH-IIT Patna DevOps certification verifiable by employers?",
    answer: "Yes — it's digitally verifiable, shareable on LinkedIn, or submitted using a unique credential ID."
  },
  {
    question: "Will this DevOps training in Bangalore help me get a job abroad, or only in India?",
    answer: "The curriculum is globally aligned, and past graduates have used it to secure opportunities in the Middle East, the UK, and Southeast Asia."
  },
  {
    question: "How is this DevOps training in Bangalore different from a general IT certificate?",
    answer: "It's domain-specific, backed by TIH-IIT Patna, and tied directly to hands-on project completion."
  },
  {
    question: "Does completing this DevOps course in Bangalore make me eligible for government or PSU tech roles?",
    answer: "The TIH-IIT Patna credential adds institutional legitimacy that's recognized in several government tech hiring contexts, particularly for digital transformation and cloud infrastructure roles."
  },
  {
    question: "Is this considered one of the devops training institute in Bangalore for career switchers?",
    answer: "Yes — with live mentorship, hands-on labs, and strong placement support, it's built specifically to help career switchers transition into DevOps roles with confidence."
  },
  {
    question: "What makes this the best DevOps institute in Bangalore for working professionals?",
    answer: "Flexible weekday and weekend batches, recorded sessions, and mentor-led doubt clearing make it manageable to pursue alongside a full-time job."
  },
  {
    question: "Do I need a technical degree to enroll in this DevOps training institute in Bangalore?",
    answer: "No formal technical degree is required — the program is open to graduates from any background who meet the minimum work experience criteria."
  },
  {
    question: "Does this DevOps certification in Bangalore include multi-cloud training, or is it limited to one platform?",
    answer: "It covers AWS, Microsoft Azure, and Google Cloud Platform, so you graduate with genuine multi-cloud exposure rather than single-vendor knowledge."
  },
  {
    question: "How long does it take to complete this DevOps course in Bangalore?",
    answer: "Most learners complete the program within 5–6 months, depending on batch pace and weekly hour commitment."
  },
  {
    question: "Can I switch from a weekday to a weekend batch mid-course in this DevOps training in Bangalore?",
    answer: "Yes, batch transfers are generally supported — reach out to the student support team to arrange this."
  },
  {
    question: "Is there a certificate of completion in addition to the DevOps certifications?",
    answer: "Yes, learners receive a program completion certificate alongside the individual vendor and TIH-IIT Patna certifications earned during the course."
  },
  {
    question: "Does this DevOps course in Bangalore provide lifetime access to recorded content?",
    answer: "Recorded sessions and course materials remain accessible for an extended period after course completion — check with admissions for the current access window."
  },
  {
    question: "Are placement guarantees legally binding, or just a marketing claim?",
    answer: "Placement support includes a structured career-fee refund policy — if no job opportunity results, the career fee (15% of total fee) is refunded, per the terms shared at enrollment."
  },
  {
    question: "What is the batch size for this DevOps training in Bangalore?",
    answer: "Batches are kept limited in size to preserve the quality of mentorship and ensure adequate 1:1 attention during live sessions."
  },
  {
    question: "Can freshers with no work experience join this DevOps training institute in Bangalore?",
    answer: "The program generally requires a minimum of 1 year of work experience in any field; freshers are encouraged to check with admissions for alternate pathways."
  }
];

export const hyderabadFaqs = [
  {
    question: "What is the fee for this devops course in Hyderabad, and are EMI options available?",
    answer: "The fee is priced competitively for the Indian market, with no-cost EMI options available through leading banks and NBFCs."
  },
  {
    question: "Are there scholarships or early-bird discounts on this devops training in Hyderabad?",
    answer: "Yes, early-bird pricing and merit-based scholarships are offered from time to time — reach out to the admissions team for current offers."
  },
  {
    question: "What's the refund policy for this devops training in Hyderabad?",
    answer: "A structured refund policy applies — if you're unsatisfied within the initial sessions, a refund can be claimed as per the terms shared at enrollment."
  },
  {
    question: "Is a free demo class available before enrolling in this devops course in Hyderabad?",
    answer: "Yes, a free demo session is available so you can evaluate teaching quality, curriculum depth, and the instructor before committing."
  },
  {
    question: "Does this devops training in Hyderabad cover CI/CD pipeline setup with Jenkins and GitHub Actions?",
    answer: "Yes — building and managing CI/CD pipelines with Jenkins, GitHub Actions, and GitLab CI forms a core module, backed by hands-on project work."
  },
  {
    question: "Is Docker and Kubernetes part of this devops course in Hyderabad?",
    answer: "Yes, both are covered in depth, including real cluster deployments and production-grade configurations."
  },
  {
    question: "Does the curriculum include Infrastructure as Code tools like Terraform and Ansible?",
    answer: "Yes — Terraform for cloud provisioning and Ansible for configuration management each get a dedicated module."
  },
  {
    question: "Is monitoring and observability (Prometheus, Grafana, ELK) covered in this devops training in Hyderabad?",
    answer: "Yes, a full observability module covers Prometheus, Grafana dashboards, and the ELK stack."
  },
  {
    question: "What scripting languages are taught in this devops course in Hyderabad?",
    answer: "Shell scripting, Python for automation, and YAML configuration."
  },
  {
    question: "Is Git and version control part of this devops training in Hyderabad?",
    answer: "Yes — Git workflows, branching strategies, and code review practices are covered before moving into CI/CD and cloud modules."
  },
  {
    question: "Are classes held on weekdays, weekends, or both?",
    answer: "Both weekday evening and weekend batches are available."
  },
  {
    question: "How many hours per week does this devops training in Hyderabad require?",
    answer: "Roughly 8–12 hours a week, covering live sessions, lab practice, and assignments."
  },
  {
    question: "What happens if I miss a live session of this devops course in Hyderabad?",
    answer: "Every session is recorded and made available within 24 hours."
  },
  {
    question: "Can I access the devops course content on mobile?",
    answer: "Yes, all recorded sessions and materials are accessible through a mobile browser."
  },
  {
    question: "What system configuration is needed for this devops training in Hyderabad?",
    answer: "A laptop with 8GB RAM and stable internet is sufficient — all lab environments are cloud-hosted."
  },
  {
    question: "Will I get access to live cloud lab environments during this devops course in Hyderabad?",
    answer: "Yes — live cloud labs on AWS, Azure, and GCP allow practice on real infrastructure."
  },
  {
    question: "Is PaperLive Learning the Best DevOps Training Institute in Hyderabad?",
    answer: "Yes. PaperLive Learning stands among the leading devops training institutes in Hyderabad, offering live instructor-led sessions, hands-on projects, coverage of AWS, Azure & GCP, Microsoft-certified trainers, and dedicated placement assistance to help learners graduate job-ready."
  },
  {
    question: "What DevOps job roles can I target after completing this devops training in Hyderabad?",
    answer: "DevOps Engineer, SRE, Cloud Infrastructure Engineer, Platform Engineer, and Release Manager, among others."
  },
  {
    question: "What's the average salary for a DevOps-certified professional in India?",
    answer: "Typically ₹7–20 LPA depending on experience, with the IIT-backed credential often helping in salary negotiations."
  },
  {
    question: "Is resume building and interview prep part of this devops training in Hyderabad?",
    answer: "Yes — resume writing support, LinkedIn optimization, and mock interviews tailored specifically for DevOps hiring rounds."
  },
  {
    question: "Are there company tie-ups for hiring after the course?",
    answer: "Yes — active hiring partnerships give graduates exclusive referral opportunities after course completion."
  },
  {
    question: "How does this devops course in Hyderabad compare to vendor certifications like AWS DevOps Professional or CKA?",
    answer: "Vendor certifications tend to be platform-specific, while this course covers the full DevOps lifecycle across multi-cloud environments."
  },
  {
    question: "Is this devops training in Hyderabad a better fit than a full-time bootcamp for someone already working in IT?",
    answer: "It's built around working professionals — flexible schedules, recorded session backups, and no requirement for full-time availability."
  },
  {
    question: "Why choose this devops training in Hyderabad over a Udemy or Coursera course?",
    answer: "Self-paced platforms mainly offer pre-recorded videos; this program adds live instruction, real cloud labs, mentor access, TIH-IIT Patna credentialing, and dedicated placement support."
  },
  {
    question: "Is there a peer community or study group for this devops course in Hyderabad batch?",
    answer: "Yes — every batch gets a dedicated peer community for doubt-sharing, project collaboration, and networking."
  },
  {
    question: "How many doubt-clearing sessions are part of this devops training in Hyderabad?",
    answer: "Weekly live doubt-clearing sessions, plus asynchronous support through the community channel."
  },
  {
    question: "Who are the devops trainers in Hyderabad for this program — academics or industry professionals?",
    answer: "All trainers are active industry practitioners with hands-on experience at product companies and global IT firms — not academics teaching purely from textbooks."
  },
  {
    question: "Is the TIH-IIT Patna DevOps certification verifiable by employers?",
    answer: "Yes — it's digitally verifiable, shareable on LinkedIn, or submitted using a unique credential ID."
  },
  {
    question: "Will this devops training in Hyderabad help me land a job abroad, or only within India?",
    answer: "The curriculum is globally aligned, and past graduates have used it to land roles in the Middle East, the UK, and Southeast Asia."
  },
  {
    question: "How is this different from a general IT certificate?",
    answer: "It's domain-specific, backed by TIH-IIT Patna, and tied directly to hands-on project completion."
  },
  {
    question: "Does completing this devops course in Hyderabad make me eligible for government or PSU tech roles?",
    answer: "The TIH-IIT Patna credential adds institutional legitimacy recognized in several government tech hiring contexts, particularly for digital transformation and cloud infrastructure roles."
  },
  {
    question: "Is this considered one of the top devops training institutes in Hyderabad for career switchers?",
    answer: "Yes — with live mentorship, hands-on labs, and strong placement support, it's built specifically to help career switchers move into DevOps roles with confidence."
  },
  {
    question: "What makes this the best devops institute in Hyderabad for working professionals?",
    answer: "Flexible weekday and weekend batches, recorded sessions, and mentor-led doubt clearing make it manageable alongside a full-time job."
  },
  {
    question: "Do I need a technical degree to enroll in this devops training institute in Hyderabad?",
    answer: "No formal technical degree is required — the program is open to graduates from any background who meet the minimum work experience criteria."
  },
  {
    question: "Does this devops training in Hyderabad include multi-cloud coverage, or just one platform?",
    answer: "It covers AWS, Microsoft Azure, and Google Cloud Platform, giving genuine multi-cloud exposure rather than single-vendor knowledge."
  },
  {
    question: "How long does it take to complete this devops course in Hyderabad?",
    answer: "Most learners complete the program within 5–6 months, depending on batch pace and weekly time commitment."
  },
  {
    question: "Can I switch from a weekday to a weekend batch mid-course?",
    answer: "Yes, batch transfers are generally supported — reach out to the student support team to arrange this."
  },
  {
    question: "Is there a certificate of completion in addition to the DevOps certifications?",
    answer: "Yes, learners receive a program completion certificate alongside the individual vendor and TIH-IIT Patna certifications earned during the course."
  },
  {
    question: "Does this devops course in Hyderabad provide lifetime access to recorded content?",
    answer: "Recorded sessions and course materials stay accessible for an extended period after completion — check with admissions for the current access window."
  },
  {
    question: "Are placement guarantees legally binding, or just a marketing claim?",
    answer: "Placement support includes a structured career-fee refund policy — if no job opportunity results, the career fee (15% of total fee) is refunded, per the terms shared at enrollment."
  },
  {
    question: "What is the batch size for this devops training in Hyderabad?",
    answer: "Batches are kept limited in size to preserve mentorship quality and ensure adequate 1:1 attention during live sessions."
  },
  {
    question: "Can freshers with no work experience join this devops training institute in Hyderabad?",
    answer: "The program generally requires a minimum of 1 year of work experience in any field; freshers are encouraged to check with admissions for alternate pathways."
  }
];

export const mumbaiFaqs = [
  {
    question: "What is the fee for this devops course in Mumbai, and are EMI options available?",
    answer: "Fees are set competitively for the Indian market, with no-cost EMI running through several established banks and NBFCs."
  },
  {
    question: "Are there scholarships or early-bird discounts on this devops training in Mumbai?",
    answer: "Periodic early-bird pricing and merit-based scholarships do exist — the admissions team can confirm what's currently on offer."
  },
  {
    question: "What's the refund policy for this devops training in Mumbai?",
    answer: "A defined refund window covers the early sessions — if the fit isn't right, a refund can be requested per the terms shared at enrollment."
  },
  {
    question: "Is a free demo class available before enrolling in this devops course in Mumbai?",
    answer: "A free demo session is offered specifically to evaluate teaching style, curriculum depth, and instructor fit before any commitment."
  },
  {
    question: "Does this devops training in Mumbai cover CI/CD pipeline setup with Jenkins and GitHub Actions?",
    answer: "CI/CD is treated as a core module — Jenkins, GitHub Actions, and GitLab CI are all included, tied together with hands-on project assignments rather than pure lecture time."
  },
  {
    question: "Is Docker and Kubernetes part of this devops course in Mumbai?",
    answer: "Yes, and the coverage goes past the basics — expect real cluster deployment exercises and configuration work modeled on production setups."
  },
  {
    question: "Does the curriculum include Infrastructure as Code tools like Terraform and Ansible?",
    answer: "Terraform and Ansible each have their own module — Terraform handles cloud provisioning, and Ansible takes care of configuration management."
  },
  {
    question: "Is monitoring and observability (Prometheus, Grafana, ELK) covered in this devops training in Mumbai?",
    answer: "Observability gets a full module of its own, working through Prometheus, building dashboards in Grafana, and analyzing logs with the ELK stack."
  },
  {
    question: "What scripting languages are taught in this devops course in Mumbai?",
    answer: "Coverage includes shell scripting, Python for automating tasks, and YAML for configuration files."
  },
  {
    question: "Is Git and version control part of this devops training in Mumbai?",
    answer: "Absolutely — it's the starting point of the program, covering workflows, branching, and code review before the curriculum shifts toward CI/CD and cloud content."
  },
  {
    question: "Are classes held on weekdays, weekends, or both?",
    answer: "Both options exist — weekday evening batches run alongside weekend batches, so either schedule works."
  },
  {
    question: "How many hours per week does this devops training in Mumbai require?",
    answer: "Plan for around 8 to 12 hours a week, covering a mix of live sessions, lab practice, and assignments."
  },
  {
    question: "What happens if I miss a live session of this devops course in Mumbai?",
    answer: "Sessions are always recorded, with the recording available within a day, so a missed class doesn't mean lost content."
  },
  {
    question: "Can I access the devops course content on mobile?",
    answer: "Yes — recorded sessions and reference materials all work fine on a mobile browser, no separate app needed."
  },
  {
    question: "What system configuration is needed for this devops training in Mumbai?",
    answer: "A basic laptop with 8GB RAM and a working internet connection is enough, since all labs are hosted in the cloud rather than run locally."
  },
  {
    question: "Will I get access to live cloud lab environments during this devops course in Mumbai?",
    answer: "Yes — the labs run live on actual AWS, Azure, and GCP infrastructure, not sandboxed simulations."
  },
  {
    question: "Is PaperLive Learning the Best DevOps Training Institute in Mumbai?",
    answer: "PaperLive Learning sits among the top-regarded devops training institutes in Mumbai, built around live instructor-led delivery, hands-on projects, multi-cloud coverage across AWS, Azure, and GCP, Microsoft-certified trainers, and placement support that carries through to actual job outcomes."
  },
  {
    question: "What DevOps job roles can I target after completing this devops training in Mumbai?",
    answer: "Common destinations include DevOps Engineer, SRE, Cloud Infrastructure Engineer, Platform Engineer, and Release Manager positions."
  },
  {
    question: "What's the average salary for a DevOps-certified professional in India?",
    answer: "Pay typically falls in the ₹7–20 LPA range depending on experience level, and having the IIT-backed credential on a resume tends to help during salary discussions."
  },
  {
    question: "Is resume building and interview prep part of this devops training in Mumbai?",
    answer: "Yes — resume writing, LinkedIn profile work, and mock interview sessions are all included, built specifically around DevOps hiring patterns."
  },
  {
    question: "Are there company tie-ups for hiring after the course?",
    answer: "Yes, active hiring partnerships open up referral routes for graduates that aren't accessible to candidates applying cold."
  },
  {
    question: "How does this devops course in Mumbai compare to vendor certifications like AWS DevOps Professional or CKA?",
    answer: "Vendor certifications focus narrowly on one platform, while this course takes on the entire DevOps lifecycle across multiple cloud providers at once."
  },
  {
    question: "Is this devops training in Mumbai a better fit than a full-time bootcamp for someone already working in IT?",
    answer: "It's structured specifically for people already employed — flexible timing, recorded sessions as a fallback, and no expectation of full-time availability."
  },
  {
    question: "Why choose this devops training in Mumbai over a Udemy or Coursera course?",
    answer: "Self-paced video platforms leave you on your own after the content; this program adds live teaching, hands-on cloud labs, mentor access, TIH-IIT Patna credentials, and placement help on top."
  },
  {
    question: "Is there a peer community or study group for this devops course in Mumbai batch?",
    answer: "Yes — each batch forms its own community for doubt discussions, project teamwork, and networking that continues past the course itself."
  },
  {
    question: "How many doubt-clearing sessions are part of this devops training in Mumbai?",
    answer: "Live doubt-clearing happens on a weekly basis, and there's also an ongoing community channel for async questions between sessions."
  },
  {
    question: "Who are the devops trainers in Mumbai for this program — academics or industry professionals?",
    answer: "Trainers come exclusively from active industry backgrounds, with hands-on time at product companies and global IT firms — not academic instruction removed from real practice."
  },
  {
    question: "Is the TIH-IIT Patna DevOps certification verifiable by employers?",
    answer: "Yes — employers can verify it digitally, either through a LinkedIn share or by checking the unique credential ID that comes with it."
  },
  {
    question: "Will this devops training in Mumbai help me land a job abroad, or only within India?",
    answer: "The syllabus is designed around global standards, and alumni have gone on to work in places like the Middle East, the UK, and Southeast Asia."
  },
  {
    question: "How is this different from a general IT certificate?",
    answer: "It's narrower and more focused by design — TIH-IIT Patna backed, and earned through actual completed projects rather than a one-time exam."
  },
  {
    question: "Does completing this devops course in Mumbai make me eligible for government or PSU tech roles?",
    answer: "It can help — the TIH-IIT Patna association carries some institutional weight in government hiring circles, particularly for cloud and digital transformation positions."
  },
  {
    question: "Is this considered one of the top devops training institutes in Mumbai for career switchers?",
    answer: "Career switchers are actually a core focus here — the mentorship, labs, and placement support are all designed with that transition in mind."
  },
  {
    question: "What makes this the best devops institute in Mumbai for working professionals?",
    answer: "The mix of flexible scheduling, recorded backups, and hands-on mentor support makes it workable alongside a regular job."
  },
  {
    question: "Do I need a technical degree to enroll in this devops training institute in Mumbai?",
    answer: "No degree requirement exists — the only real bar is the minimum work experience criterion, open to any educational background."
  },
  {
    question: "Does this devops training in Mumbai include multi-cloud coverage, or just one platform?",
    answer: "It spans three major providers — AWS, Azure, and GCP — so the exposure genuinely counts as multi-cloud rather than single-vendor."
  },
  {
    question: "How long does it take to complete this devops course in Mumbai?",
    answer: "Typical completion falls around 5 to 6 months, though it shifts a bit depending on batch speed and weekly effort."
  },
  {
    question: "Can I switch from a weekday to a weekend batch mid-course?",
    answer: "Yes, switching batches is usually possible — just coordinate with the student support team to set it up."
  },
  {
    question: "Is there a certificate of completion in addition to the DevOps certifications?",
    answer: "Yes — there's a separate program completion certificate on top of the vendor certifications and the TIH-IIT Patna credential."
  },
  {
    question: "Does this devops course in Mumbai provide lifetime access to recorded content?",
    answer: "Access to recorded content lasts well beyond the course itself, though the exact time window is best confirmed with admissions."
  },
  {
    question: "Are placement guarantees legally binding, or just a marketing claim?",
    answer: "It's backed by a concrete policy — a 15% career-fee refund kicks in if no job opportunity comes through, under the terms set at enrollment."
  },
  {
    question: "What is the batch size for this devops training in Mumbai?",
    answer: "Batches stay small on purpose, so mentorship quality and individual attention don't get diluted."
  },
  {
    question: "Can freshers with no work experience join this devops training institute in Mumbai?",
    answer: "Generally, 1 year of work experience is expected; freshers are better off checking directly with admissions for any alternate entry option."
  }
];

export const delhiFaqs = [
  {
    question: "What is the fee for this devops course in Delhi, and are EMI options available?",
    answer: "Pricing stays competitive for the Indian market, and no-cost EMI runs through several major banks and NBFCs."
  },
  {
    question: "Are there scholarships or early-bird discounts on this devops training in Delhi?",
    answer: "Early-bird pricing and merit-based scholarships surface periodically — the admissions team can confirm what's live right now."
  },
  {
    question: "What's the refund policy for these devops classes in Delhi?",
    answer: "A refund window covers the initial sessions; if things aren't working out, a refund can be claimed as per the terms shared at enrollment."
  },
  {
    question: "Is a free demo class available before enrolling in this devops course in Delhi?",
    answer: "Yes — a free demo session lets you judge teaching quality, curriculum depth, and instructor fit before any payment happens."
  },
  {
    question: "Does this devops training in Delhi cover CI/CD pipeline setup with Jenkins and GitHub Actions?",
    answer: "CI/CD is treated as a core module — Jenkins, GitHub Actions, and GitLab CI all get covered with hands-on project work attached."
  },
  {
    question: "Is Docker and Kubernetes part of this devops course in Delhi?",
    answer: "Both get covered in depth, extending into real cluster deployments and production-grade configuration work."
  },
  {
    question: "Does the curriculum include Infrastructure as Code tools like Terraform and Ansible?",
    answer: "Both tools get dedicated modules — Terraform for cloud provisioning, Ansible for configuration management."
  },
  {
    question: "Is monitoring and observability (Prometheus, Grafana, ELK) covered in this devops training in Delhi?",
    answer: "A full observability module walks through Prometheus, Grafana dashboards, and the ELK stack."
  },
  {
    question: "What scripting languages are taught in this devops course in Delhi?",
    answer: "Shell scripting, Python for automation work, and YAML configuration all get covered."
  },
  {
    question: "Is Git and version control part of this devops training in Delhi?",
    answer: "Git workflows, branching strategies, and code review practices form the base before the curriculum moves into CI/CD and cloud modules."
  },
  {
    question: "Are classes held on weekdays, weekends, or both?",
    answer: "Weekday evening batches and weekend batches both run, covering either scheduling preference."
  },
  {
    question: "How many hours per week do these devops classes in Delhi require?",
    answer: "Around 8–12 hours weekly, spread across live sessions, lab practice, and assignments."
  },
  {
    question: "What happens if I miss a live session of this devops course in Delhi?",
    answer: "Every session gets recorded and posted within 24 hours, so nothing gets lost."
  },
  {
    question: "Can I access the devops course content on mobile?",
    answer: "Yes — recorded sessions and materials stay accessible through a mobile browser."
  },
  {
    question: "What system configuration is needed for this devops training in Delhi?",
    answer: "A laptop with 8GB RAM and stable internet covers it, since lab environments run entirely in the cloud."
  },
  {
    question: "Will I get access to live cloud lab environments during this devops course in Delhi?",
    answer: "Yes — live cloud labs across AWS, Azure, and GCP let you practice on genuine infrastructure."
  },
  {
    question: "Is PaperLive Learning the Best DevOps Training Institute in Delhi?",
    answer: "PaperLive Learning ranks among the leading devops training institutes in Delhi, combining live instructor-led sessions, hands-on project work, coverage across AWS, Azure, and GCP, Microsoft-certified trainers, and dedicated placement assistance to help learners graduate job-ready."
  },
  {
    question: "What DevOps job roles can I target after completing this devops training in Delhi?",
    answer: "Typical outcomes include DevOps Engineer, SRE, Cloud Infrastructure Engineer, Platform Engineer, and Release Manager roles."
  },
  {
    question: "What's the average salary for a DevOps-certified professional in India?",
    answer: "Salaries typically fall between ₹7–20 LPA depending on experience, and the IIT-backed credential often adds leverage in negotiations."
  },
  {
    question: "Is resume building and interview prep part of this devops training in Delhi?",
    answer: "Yes — resume writing support, LinkedIn optimization, and mock interviews all get tailored specifically for DevOps hiring rounds."
  },
  {
    question: "Are there company tie-ups for hiring after the course?",
    answer: "Active hiring partnerships mean graduates get exclusive referral opportunities once the course wraps up."
  },
  {
    question: "How does this devops course in Delhi compare to vendor certifications like AWS DevOps Professional or CKA?",
    answer: "Vendor certifications stay tied to one platform; this course spans the full DevOps lifecycle across multi-cloud environments instead."
  },
  {
    question: "Is this devops training in Delhi a better fit than a full-time bootcamp for someone already working in IT?",
    answer: "It's designed around working professionals — flexible schedules, recorded backups, and no requirement for full-time availability."
  },
  {
    question: "Why choose this devops training in Delhi over a Udemy or Coursera course?",
    answer: "Self-paced platforms mostly hand over pre-recorded videos; this program adds live instruction, genuine cloud lab access, mentor contact, TIH-IIT Patna credentialing, and dedicated placement support on top."
  },
  {
    question: "Is there a peer community or study group for this devops course in Delhi batch?",
    answer: "Every batch gets its own dedicated peer community for doubt-sharing, project collaboration, and networking."
  },
  {
    question: "How many doubt-clearing sessions are part of this devops training in Delhi?",
    answer: "Weekly live doubt-clearing sessions run, plus async support through the community channel in between."
  },
  {
    question: "Who are the devops trainers in Delhi for this program — academics or industry professionals?",
    answer: "Every trainer is an active industry practitioner with real hands-on experience at product companies and global IT firms — not academic instruction disconnected from practice."
  },
  {
    question: "Is the TIH-IIT Patna DevOps certification verifiable by employers?",
    answer: "Yes — it's digitally verifiable, shareable directly on LinkedIn, or checked through a unique credential ID."
  },
  {
    question: "Will this devops training in Delhi help me land a job abroad, or only within India?",
    answer: "The curriculum aligns with global standards, and past graduates have used it to secure roles in the Middle East, the UK, and Southeast Asia."
  },
  {
    question: "How is this different from a general IT certificate?",
    answer: "It's domain-specific, carries TIH-IIT Patna backing, and ties directly to completed hands-on project work rather than a generic exam pass."
  },
  {
    question: "Does completing this devops course in Delhi make me eligible for government or PSU tech roles?",
    answer: "The TIH-IIT Patna credential adds institutional legitimacy recognized in several government tech hiring contexts, particularly around digital transformation and cloud infrastructure roles."
  },
  {
    question: "Is this considered one of the top devops training institutes in Delhi for career switchers?",
    answer: "It's built specifically for that shift — live mentorship, hands-on labs, and strong placement support all aim at helping career switchers move into DevOps roles with genuine confidence."
  },
  {
    question: "What makes this the best devops institute in Delhi for working professionals?",
    answer: "Flexible weekday and weekend batches, recorded sessions, and mentor-led doubt clearing make it realistic to pursue alongside a full-time job."
  },
  {
    question: "Do I need a technical degree to enroll in this devops training institute in Delhi?",
    answer: "No formal technical degree is required — eligibility rests on meeting the minimum work experience criteria, regardless of academic background."
  },
  {
    question: "Does this devops training in Delhi include multi-cloud coverage, or just one platform?",
    answer: "Coverage spans AWS, Microsoft Azure, and Google Cloud Platform, delivering genuine multi-cloud exposure rather than single-vendor knowledge."
  },
  {
    question: "How long does it take to complete this devops course in Delhi?",
    answer: "Most learners finish within 5–6 months, depending on batch pace and weekly time commitment."
  },
  {
    question: "Can I switch from a weekday to a weekend batch mid-course?",
    answer: "Batch transfers are generally supported — the student support team can help arrange this."
  },
  {
    question: "Is there a certificate of completion in addition to the DevOps certifications?",
    answer: "Yes — alongside the individual vendor and TIH-IIT Patna certifications, learners also receive a program completion certificate."
  },
  {
    question: "Does this devops course in Delhi provide lifetime access to recorded content?",
    answer: "Recorded sessions and materials stay accessible for an extended period after completion — admissions can confirm the current access window."
  },
  {
    question: "Are placement guarantees legally binding, or just a marketing claim?",
    answer: "Placement support runs on a structured career-fee refund policy — if no job opportunity results, the career fee (15% of total fee) gets refunded per the terms agreed at enrollment."
  },
  {
    question: "What is the batch size for this devops training in Delhi?",
    answer: "Batches stay limited in size to protect mentorship quality and ensure real 1:1 attention during live sessions."
  },
  {
    question: "Can freshers with no work experience join this devops training institute in Delhi?",
    answer: "The program generally requires a minimum of 1 year of work experience in any field; freshers should check directly with admissions about alternate pathways."
  }
];

export const puneFaqs = [
  {
    question: "What is the fee for this devops course in Pune, and are EMI options available?",
    answer: "Pricing is set competitively for the Indian market, and no-cost EMI is available through several major banks and NBFCs."
  },
  {
    question: "Are there scholarships or early-bird discounts on this devops training in Pune?",
    answer: "Early-bird pricing windows and merit-based scholarships do come up periodically — the admissions team can confirm what's currently active."
  },
  {
    question: "What's the refund policy for these devops classes in Pune?",
    answer: "There's a defined refund window covering the initial sessions; if the fit isn't right, a refund can be claimed based on the terms shared at the time of enrollment."
  },
  {
    question: "Is a free demo class available before enrolling in this devops course in Pune?",
    answer: "Yes — a free demo session is offered upfront specifically so you can judge teaching quality, curriculum depth, and instructor style before paying anything."
  },
  {
    question: "Does this devops training in Pune cover CI/CD pipeline setup with Jenkins and GitHub Actions?",
    answer: "CI/CD tooling is a core part of the curriculum — Jenkins, GitHub Actions, and GitLab CI are all covered with real project work attached, not just conceptual walkthroughs."
  },
  {
    question: "Is Docker and Kubernetes part of this devops course in Pune?",
    answer: "Both are covered thoroughly, extending into real cluster deployment scenarios and configurations you'd actually see in production environments."
  },
  {
    question: "Does the curriculum include Infrastructure as Code tools like Terraform and Ansible?",
    answer: "Both get their own dedicated modules — Terraform handles cloud provisioning, while Ansible covers configuration management."
  },
  {
    question: "Is monitoring and observability (Prometheus, Grafana, ELK) covered in this devops training in Pune?",
    answer: "There's a dedicated observability module built around Prometheus, Grafana dashboard building, and the ELK stack."
  },
  {
    question: "What scripting languages are taught in this devops course in Pune?",
    answer: "The curriculum includes shell scripting, Python for automation tasks, and YAML for configuration work."
  },
  {
    question: "Is Git and version control part of this devops training in Pune?",
    answer: "Git forms the starting point of the program — workflows, branching strategies, and code review practices are all covered before the curriculum moves into CI/CD and cloud-focused modules."
  },
  {
    question: "Are classes held on weekdays, weekends, or both?",
    answer: "Batches run on both weekday evenings and weekends, so scheduling flexibility isn't an issue."
  },
  {
    question: "How many hours per week do these devops classes in Pune require?",
    answer: "Expect somewhere between 8 and 12 hours weekly, spread across live sessions, lab time, and assignment work."
  },
  {
    question: "What happens if I miss a live session of this devops course in Pune?",
    answer: "Nothing is lost — every session gets recorded and posted within 24 hours of going live."
  },
  {
    question: "Can I access the devops course content on mobile?",
    answer: "Recorded sessions and course materials are all reachable through a mobile browser, so a laptop isn't strictly required for review."
  },
  {
    question: "What system configuration is needed for this devops training in Pune?",
    answer: "A laptop with at least 8GB RAM and a dependable internet connection covers it — lab environments run in the cloud, so local hardware demands stay light."
  },
  {
    question: "Will I get access to live cloud lab environments during this devops course in Pune?",
    answer: "Yes — labs run live across AWS, Azure, and GCP, so practice happens on genuine infrastructure rather than simulated environments."
  },
  {
    question: "Is PaperLive Learning the Best DevOps Training Institute in Pune?",
    answer: "PaperLive Learning is positioned among the top devops training institutes in Pune, combining live instructor-led delivery, hands-on project work, coverage across AWS, Azure, and GCP, Microsoft-certified trainers, and structured placement assistance to get learners job-ready."
  },
  {
    question: "What DevOps job roles can I target after completing this devops training in Pune?",
    answer: "Common outcomes include DevOps Engineer, SRE, Cloud Infrastructure Engineer, Platform Engineer, and Release Manager roles."
  },
  {
    question: "What's the average salary for a DevOps-certified professional in India?",
    answer: "Salaries generally land between ₹7–20 LPA depending on experience level, and the IIT-backed credential tends to add leverage during negotiations."
  },
  {
    question: "Is resume building and interview prep part of this devops training in Pune?",
    answer: "Resume writing support, LinkedIn optimization, and mock interview practice are all included, each geared specifically toward DevOps hiring processes."
  },
  {
    question: "Are there company tie-ups for hiring after the course?",
    answer: "Yes, established hiring partnerships mean graduates get referral opportunities that aren't available to the general applicant pool."
  },
  {
    question: "How does this devops course in Pune compare to vendor certifications like AWS DevOps Professional or CKA?",
    answer: "Vendor certifications stay locked to a single platform, whereas this course spans the entire DevOps lifecycle across a multi-cloud setup."
  },
  {
    question: "Is this devops training in Pune a better fit than a full-time bootcamp for someone already working in IT?",
    answer: "It's built with working professionals specifically in mind — schedules stay flexible, sessions get recorded as backup, and full-time availability was never a requirement to begin with."
  },
  {
    question: "Why choose this devops training in Pune over a Udemy or Coursera course?",
    answer: "Self-paced platforms hand you a video library and leave the rest to you; this program layers in live instruction, genuine cloud lab access, direct mentor contact, TIH-IIT Patna credentialing, and placement support on top."
  },
  {
    question: "Is there a peer community or study group for this devops course in Pune batch?",
    answer: "Every batch gets its own peer group for sharing doubts, collaborating on projects, and building a network beyond the classroom."
  },
  {
    question: "How many doubt-clearing sessions are part of this devops training in Pune?",
    answer: "Doubt-clearing happens weekly through live sessions, with additional async support available through the community channel in between."
  },
  {
    question: "Who are the devops trainers in Pune for this program — academics or industry professionals?",
    answer: "Every trainer comes from an active industry background with real hands-on time at product companies and global IT firms — this isn't academic instruction detached from practice."
  },
  {
    question: "Is the TIH-IIT Patna DevOps certification verifiable by employers?",
    answer: "The credential is digitally verifiable — it can be shared directly on LinkedIn or checked using a unique credential ID."
  },
  {
    question: "Will this devops training in Pune help me land a job abroad, or only within India?",
    answer: "The curriculum follows globally relevant standards, and graduates have gone on to secure roles in markets including the Middle East, the UK, and Southeast Asia."
  },
  {
    question: "How is this different from a general IT certificate?",
    answer: "It's tied to a specific domain, carries TIH-IIT Patna backing, and is directly linked to completed hands-on project work — not a generic pass/fail exam."
  },
  {
    question: "Does completing this devops course in Pune make me eligible for government or PSU tech roles?",
    answer: "The TIH-IIT Patna backing does carry institutional weight in certain government tech hiring contexts, especially around digital transformation and cloud infrastructure roles."
  },
  {
    question: "Is this considered one of the top devops training institutes in Pune for career switchers?",
    answer: "It's specifically structured for that transition — live mentorship, hands-on labs, and dedicated placement support are all aimed at helping career switchers move into DevOps roles with genuine confidence."
  },
  {
    question: "What makes this the best devops institute in Pune for working professionals?",
    answer: "The combination of flexible weekday/weekend batches, recorded session backups, and mentor-led doubt clearing makes it realistic to pursue alongside a full-time job."
  },
  {
    question: "Do I need a technical degree to enroll in this devops training institute in Pune?",
    answer: "No formal technical degree is required — eligibility is based on meeting the minimum work experience requirement, regardless of academic background."
  },
  {
    question: "Does this devops training in Pune include multi-cloud coverage, or just one platform?",
    answer: "Coverage spans AWS, Microsoft Azure, and Google Cloud Platform, so the exposure is genuinely multi-cloud rather than tied to a single vendor."
  },
  {
    question: "How long does it take to complete this devops course in Pune?",
    answer: "Most learners wrap up the program in 5–6 months, though the exact timeline depends on batch pace and weekly time invested."
  },
  {
    question: "Can I switch from a weekday to a weekend batch mid-course?",
    answer: "Batch transfers are generally accommodated — the student support team can help arrange the switch."
  },
  {
    question: "Is there a certificate of completion in addition to the DevOps certifications?",
    answer: "Yes — beyond the individual vendor and TIH-IIT Patna certifications, learners also receive a separate program completion certificate."
  },
  {
    question: "Does this devops course in Pune provide lifetime access to recorded content?",
    answer: "Recorded sessions and materials stay accessible well beyond course completion; admissions can confirm the exact access window currently in place."
  },
  {
    question: "Are placement guarantees legally binding, or just a marketing claim?",
    answer: "The backing here is a structured career-fee refund policy — if no job opportunity comes through, the career fee (15% of the total fee) is refunded per the terms agreed at enrollment."
  },
  {
    question: "What is the batch size for this devops training in Pune?",
    answer: "Batch sizes are deliberately kept small to protect mentorship quality and ensure everyone gets real 1:1 attention during live sessions."
  },
  {
    question: "Can freshers with no work experience join this devops training institute in Pune?",
    answer: "The standard requirement is a minimum of 1 year of work experience in any field; freshers should check directly with admissions about alternate entry pathways."
  }
];

export const chennaiFaqs = [
  {
    question: "What is the fee for this devops course in Chennai, and are EMI options available?",
    answer: "Fees are set at a competitive rate for the Indian market, and no-cost EMI runs through several established banks and NBFCs."
  },
  {
    question: "Are there scholarships or early-bird discounts on this devops training in Chennai?",
    answer: "Periodic early-bird pricing and merit-based scholarships do exist — current offers can be confirmed directly with the admissions team."
  },
  {
    question: "What's the refund policy for this devops training in Chennai?",
    answer: "A defined refund window applies to the early sessions — if the fit isn't right, a refund can be requested per the terms laid out at enrollment."
  },
  {
    question: "Is a free demo class available before enrolling in this devops course in Chennai?",
    answer: "A free demo session is offered specifically for this — evaluating teaching style, curriculum depth, and instructor fit before any commitment is made."
  },
  {
    question: "Does this devops training in Chennai cover CI/CD pipeline setup with Jenkins and GitHub Actions?",
    answer: "Yes — Jenkins, GitHub Actions, and GitLab CI form a core CI/CD module, reinforced through hands-on project work rather than just lecture content."
  },
  {
    question: "Is Docker and Kubernetes part of this devops course in Chennai?",
    answer: "Both get thorough coverage, extending into real cluster deployment work and configurations built to production standards."
  },
  {
    question: "Does the curriculum include Infrastructure as Code tools like Terraform and Ansible?",
    answer: "Each tool gets its own dedicated module — Terraform for provisioning cloud infrastructure, Ansible for configuration management."
  },
  {
    question: "Is monitoring and observability (Prometheus, Grafana, ELK) covered in this devops training in Chennai?",
    answer: "A dedicated observability module covers Prometheus for monitoring, Grafana for dashboarding, and the ELK stack for log analysis."
  },
  {
    question: "What scripting languages are taught in this devops course in Chennai?",
    answer: "The curriculum touches shell scripting, Python for automation work, and YAML for configuration files."
  },
  {
    question: "Is Git and version control part of this devops training in Chennai?",
    answer: "Git comes first in the sequence — workflows, branching models, and code review practices, all covered before the program shifts into CI/CD and cloud modules."
  },
  {
    question: "Are classes held on weekdays, weekends, or both?",
    answer: "Both weekday evening batches and weekend batches run in parallel, covering either preference."
  },
  {
    question: "How many hours per week does this devops training in Chennai require?",
    answer: "Somewhere in the 8–12 hour range weekly, split across live sessions, lab time, and assignment work."
  },
  {
    question: "What happens if I miss a live session of this devops course in Chennai?",
    answer: "Every session gets recorded and uploaded within 24 hours, so nothing gets missed permanently."
  },
  {
    question: "Can I access the devops course content on mobile?",
    answer: "All recorded content and materials open fine through a mobile browser — no dedicated app or laptop requirement to review past sessions."
  },
  {
    question: "What system configuration is needed for this devops training in Chennai?",
    answer: "An 8GB RAM laptop with a reliable internet connection handles it — lab work runs on cloud-hosted environments, keeping local hardware needs light."
  },
  {
    question: "Will I get access to live cloud lab environments during this devops course in Chennai?",
    answer: "Live labs across AWS, Azure, and GCP give you real infrastructure to practice on, not simulated environments."
  },
  {
    question: "Is PaperLive Learning the Best DevOps Training Institute in Chennai?",
    answer: "PaperLive Learning sits among the top-regarded devops training institutes in Chennai, built around live instructor-led delivery, hands-on projects, multi-cloud coverage across AWS, Azure, and GCP, Microsoft-certified trainers, and dedicated placement support that carries through to job outcomes."
  },
  {
    question: "What DevOps job roles can I target after completing this devops training in Chennai?",
    answer: "Graduates typically move into roles like DevOps Engineer, SRE, Cloud Infrastructure Engineer, Platform Engineer, or Release Manager."
  },
  {
    question: "What's the average salary for a DevOps-certified professional in India?",
    answer: "Salaries generally range from ₹7–20 LPA based on experience, with the IIT-backed credential often carrying weight in negotiations."
  },
  {
    question: "Is resume building and interview prep part of this devops training in Chennai?",
    answer: "Resume writing support, LinkedIn optimization, and mock interview practice are all built in, each specifically geared toward DevOps hiring processes."
  },
  {
    question: "Are there company tie-ups for hiring after the course?",
    answer: "Established hiring partnerships give graduates access to referral opportunities not open to general applicants."
  },
  {
    question: "How does this devops course in Chennai compare to vendor certifications like AWS DevOps Professional or CKA?",
    answer: "Vendor-specific certifications stay locked to one platform; this program covers the full DevOps lifecycle across a genuinely multi-cloud environment."
  },
  {
    question: "Is this devops training in Chennai a better fit than a full-time bootcamp for someone already working in IT?",
    answer: "Working professionals are the core design target here — flexible schedules, recorded backups for missed content, and zero requirement for full-time availability."
  },
  {
    question: "Why choose this devops training in Chennai over a Udemy or Coursera course?",
    answer: "Self-paced platforms mostly hand you pre-recorded content and leave you to it; this program adds live instruction, genuine cloud lab access, direct mentor contact, TIH-IIT Patna credentialing, and structured placement support."
  },
  {
    question: "Is there a peer community or study group for this devops course in Chennai batch?",
    answer: "Each batch gets its own dedicated peer community, built for doubt-sharing, project collaboration, and ongoing networking."
  },
  {
    question: "How many doubt-clearing sessions are part of this devops training in Chennai?",
    answer: "Weekly live doubt-clearing sessions run alongside asynchronous support through the batch's community channel."
  },
  {
    question: "Who are the devops trainers in Chennai for this program — academics or industry professionals?",
    answer: "Trainers come exclusively from active industry backgrounds, with hands-on time at product companies and global IT firms — not academic instruction removed from practice."
  },
  {
    question: "Is the TIH-IIT Patna DevOps certification verifiable by employers?",
    answer: "The credential is digitally verifiable, shareable directly on LinkedIn, or checked via a unique credential ID assigned at issuance."
  },
  {
    question: "Will this devops training in Chennai help me land a job abroad, or only within India?",
    answer: "The curriculum follows globally relevant standards, and past graduates have used it to land roles across the Middle East, the UK, and Southeast Asia."
  },
  {
    question: "How is this different from a general IT certificate?",
    answer: "This is domain-specific, carries TIH-IIT Patna institutional backing, and is directly linked to completed project work rather than a generic pass/fail exam."
  },
  {
    question: "Does completing this devops course in Chennai make me eligible for government or PSU tech roles?",
    answer: "The TIH-IIT Patna backing brings institutional legitimacy that's recognized in certain government tech hiring contexts, particularly around digital transformation and cloud infrastructure work."
  },
  {
    question: "Is this considered one of the top devops training institutes in Chennai for career switchers?",
    answer: "This is specifically structured for that exact transition — live mentorship, hands-on labs, and dedicated placement support built to help career switchers move into DevOps roles with real confidence."
  },
  {
    question: "What makes this the best devops institute in Chennai for working professionals?",
    answer: "Flexible weekday and weekend scheduling, recorded session backups, and mentor-led doubt clearing keep this realistic to pursue alongside a full-time job."
  },
  {
    question: "Do I need a technical degree to enroll in this devops training institute in Chennai?",
    answer: "No formal technical degree is required — eligibility rests entirely on meeting the minimum work experience requirement, regardless of academic background."
  },
  {
    question: "Does this devops training in Chennai include multi-cloud coverage, or just one platform?",
    answer: "Coverage spans AWS, Microsoft Azure, and Google Cloud Platform — genuine multi-cloud exposure rather than dependence on a single vendor."
  },
  {
    question: "How long does it take to complete this devops course in Chennai?",
    answer: "Most learners wrap the program up in 5–6 months, depending on batch pacing and how many hours get committed weekly."
  },
  {
    question: "Can I switch from a weekday to a weekend batch mid-course?",
    answer: "Batch transfers are generally accommodated — the student support team handles arranging this on request."
  },
  {
    question: "Is there a certificate of completion in addition to the DevOps certifications?",
    answer: "A separate program completion certificate is issued alongside the individual vendor and TIH-IIT Patna certifications earned throughout the course."
  },
  {
    question: "Does this devops course in Chennai provide lifetime access to recorded content?",
    answer: "Recorded sessions and materials remain accessible for an extended window past course completion — admissions can confirm the exact duration currently in place."
  },
  {
    question: "Are placement guarantees legally binding, or just a marketing claim?",
    answer: "The backing here comes from a structured career-fee refund policy — if no job opportunity materializes, the career fee (15% of total fee) gets refunded per the terms agreed at enrollment."
  },
  {
    question: "What is the batch size for this devops training in Chennai?",
    answer: "Batch sizes stay intentionally small, protecting mentorship quality and ensuring real 1:1 attention during live sessions."
  },
  {
    question: "Can freshers with no work experience join this devops training institute in Chennai?",
    answer: "The standard eligibility bar is 1 year of work experience in any field; freshers should reach out to admissions directly to check for alternate entry routes."
  }
];

/**
 * City-specific FAQ sets, keyed by the city constant.
 * To add a new city: define its FAQ array above, import the city constant
 * from constants/AzureDevops, and add one entry here (e.g. [CHENNAI]: chennaiFaqs).
 */
export const cityFaqs = {
  [BANGALORE]: bangaloreFaqs,
  [HYDERABAD]: hyderabadFaqs,
  [MUMBAI]: mumbaiFaqs,
  [DELHI]: delhiFaqs,
  [PUNE]: puneFaqs,
  [CHENNAI]: chennaiFaqs,
};
